import React from 'react'

const BarcodePinkIcon = () => (
  <svg width="51px" height="51px" viewBox="0 0 70 70" version="1.1">
    <title>barcode_icon</title>
    <g id="product-designs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="barcode_icon">
        <circle id="bound" fill="#FEDFDE" cx="35" cy="35" r="35" />
        <g id="noun_Barcode_2011111" opacity="0.699999988" transform="translate(18.000000, 26.000000)" fill="#000000" fillRule="nonzero">
          <rect id="Rectangle" x="0.177083333" y="0.0708333333" width="2.30208333" height="18.3104167" />
          <rect id="Rectangle" x="9.59791667" y="0.0708333333" width="1.87708333" height="18.3104167" />
          <rect id="Rectangle" x="13.1041667" y="0.0708333333" width="1.87708333" height="18.3104167" />
          <rect id="Rectangle" x="16.6104167" y="0.0708333333" width="4.71041667" height="18.3104167" />
          <rect id="Rectangle" x="22.9145833" y="0.0708333333" width="1.87708333" height="18.3104167" />
          <rect id="Rectangle" x="26.4208333" y="0.0708333333" width="1.87708333" height="18.3104167" />
          <rect id="Rectangle" x="29.9270833" y="0.0708333333" width="3.89583333" height="18.3104167" />
          <rect id="Rectangle" x="4.07291667" y="0.0708333333" width="3.89583333" height="18.3104167" />
        </g>
      </g>
    </g>
  </svg>
)

export default BarcodePinkIcon
